import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../../capabilities';
import { waitForElement } from '../../../common/utils';
import { NOTIFICATIONS_BANNER_COMPONENT, Tags } from '../../constants';
import { Channels } from '../constants';
import { getBannerStyle, getPath, getQueryParams } from '../internal';
const NAVIGATION_BANNER_IFRAME_ID = 'in-app-notifications-banner-iframe';
export const bannerNotificationsComponentDef = defineComponent(NOTIFICATIONS_BANNER_COMPONENT, () => ({
  name: NOTIFICATIONS_BANNER_COMPONENT,
  path: getPath({
    channel: Channels.BANNERS,
    allowHubless: true
  }),
  enableHubless: true,
  queryParams: getQueryParams(),
  iframeProps: {
    id: NAVIGATION_BANNER_IFRAME_ID,
    style: getBannerStyle()
  },
  renderTo: () => waitForElement('#notificationBannerContainer'),
  initiallyOpen: true,
  deferLoading: false,
  capabilities: [capabilities.RESTYLE_CAP.getName()],
  tags: [Tags.BANNER]
}));